<template>
	<app-tooltip
		class="search-panel-toggle"
		:text="props.tooltip"
	>
		<template #activator>
			<div
				class="search-panel-toggle__btn"
				@click="emit('click')"
				@mouseenter="isHovered = true"
				@mouseleave="isHovered = false"
			>
				<app-icon
					:class="{ 'search-panel-toggle__icon--up': props.direction === 'up' }"
					name="chevron-down"
					size="16px"
					:color="isHovered ? '#499259' : '#979797'"
				/>
			</div>
		</template>
	</app-tooltip>
</template>

<script setup lang="ts">
import { ref } from "vue";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import AppTooltip from "@/components/ui-kit/tooltip/AppTooltip.vue";

const props = defineProps<{
	direction: 'up' | 'down',
	tooltip: string
}>()

const emit = defineEmits<{
	(e: 'click'): void
}>()

const isHovered = ref(false)
</script>

<style scoped lang="scss">
.search-panel-toggle {
	flex-shrink: 0;
	line-height: 0;

	&__btn {
		display: flex;
		align-items: center;
		justify-content: center;
		width: 20px;
		height: 20px;
		border-radius: 8px;
		background-color: #fff;
		box-shadow: 0 1px 4px 0 #00000033;
		cursor: pointer;
	}

	&__icon--up {
		transform: rotate(180deg);
	}
}
</style>
